import AuthAxios from '@/lib/api/axios/AuthAxios'

export type BillingProviderName = 'stripe' | 'paddle'

/**
 * Public, non-secret config returned from the backend's
 * GET /api/v1/billing/config endpoint. Used to bootstrap the matching
 * client-side SDK (Stripe.js or @paddle/paddle-js).
 */
export interface BillingProviderPublicConfig {
  provider: BillingProviderName
  publicKey: string
  /** Paddle environment label ("sandbox" | "production"); null on Stripe. */
  environment: string | null
}

export async function getBillingConfig(): Promise<BillingProviderPublicConfig> {
  const response = await AuthAxios.get<BillingProviderPublicConfig>(
    '/api/v1/billing/config',
  )
  return response.data
}
